// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { AccountInquiryModal } from "@keller/App/Store/Reducers/xAccountInquiry";

const accountInquiryUrl = "/api/ksc/accountInquiry";

export interface GetAccountInquiryApiParameter extends ApiParameter {
    asOfDate?: string;
}

export function getAccountInquiry(parameter: GetAccountInquiryApiParameter) {
    return get<AccountInquiryModal>(`${accountInquiryUrl}`, parameter);
}
